(function() {
    'use strict';

    angular
        .module('c3WebApp')
        .controller('BrazilianCitizenDeleteController',BrazilianCitizenDeleteController);

    BrazilianCitizenDeleteController.$inject = ['$uibModalInstance', 'entity', 'BrazilianCitizen'];

    function BrazilianCitizenDeleteController($uibModalInstance, entity, BrazilianCitizen) {
        var vm = this;

        vm.brazilianCitizen = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BrazilianCitizen.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
